import { IconoirCalendar } from "@ey-xd/motif-icon";
import { MotifIcon } from "@ey-xd/motif-react";
import { ProvisionBillingPreview } from "../../../../../store/slices/ProvisionBillingPreviewSlice";
import {
  formatDateOnly,
  formatDateOnlyRange,
} from "../../../../../utils/dateFunction";
import SkuProvisionSummary from "./SkuProvisionSummary/SkuProvisionSummary";
import { ProvisionDisplayDetails } from "../types";
import "./CompletionConfirmationStep.scss";

interface CompletionConfirmationStepProps {
  details: ProvisionDisplayDetails;
  provisionCompletionDate: string;
  preview: ProvisionBillingPreview | null;
}

const CompletionConfirmationStep = ({
  details,
  provisionCompletionDate,
  preview,
}: CompletionConfirmationStepProps) => {
  const billingLabel =
    details.interval === "One Time" ? "Billing date" : "First billing period";
  let billingValue = "Unavailable";

  if (preview?.billingDisplayType === "date") {
    billingValue = formatDateOnly(preview.billingDate);
  }

  if (preview?.billingDisplayType === "period") {
    billingValue = formatDateOnlyRange(
      preview.firstBillingPeriodStartDate,
      preview.firstBillingPeriodEndDate,
    );
  }

  return (
    <>
      <p className="sku-provision-intro">
        Review the details below before marking this SKU as{" "}
        <strong>Complete</strong>.
      </p>
      <p className="sku-provision-warning">
        <strong>Important:</strong> This action cannot be undone.
      </p>
      <SkuProvisionSummary details={details} />
      <div className="sku-provision-confirmation-dates">
        <div>
          <span>Provision completion</span>
          <strong>
            <MotifIcon iconFunction={IconoirCalendar} size="20" />
            {formatDateOnly(provisionCompletionDate)}
          </strong>
        </div>
        <div>
          <span>{billingLabel}</span>
          <strong>
            <MotifIcon iconFunction={IconoirCalendar} size="20" />
            {billingValue}
          </strong>
        </div>
      </div>
    </>
  );
};

export default CompletionConfirmationStep;
